import { render, staticRenderFns } from "./JalousieOpen.vue?vue&type=template&id=afa6c480&scoped=true&"
import script from "./JalousieOpen.vue?vue&type=script&lang=js&"
export * from "./JalousieOpen.vue?vue&type=script&lang=js&"
import style0 from "./JalousieOpen.vue?vue&type=style&index=0&id=afa6c480&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa6c480",
  null
  
)

export default component.exports